module.exports = __webpack_public_path__ + "img/poster-index.158b772b.png";